export default __webpack_public_path__ + "static/media/total.feef4e2d.svg";